import FaClose from "@/components/SVG/Fontawesome/FaClose";
import FeedbackContent from "./FeedbackContent";
import { Dialog } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { resetOffCanvasView, selectDislikeFeedbackIntent } from "@/store/slices/offCanvas";

const DislikeFeedbackModal = (props: { questionId: number }) => {
  const showDislikeFeedbackIntent = useSelector(selectDislikeFeedbackIntent);
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(resetOffCanvasView());
  }

  return (
    <>
      <Dialog as="div" open={showDislikeFeedbackIntent} className="relative z-[1055]" onClose={closeModal}>
        <div className="fixed inset-0 bg-black/60" />

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Dialog.Panel className="prose flex w-full max-w-max transform overflow-hidden rounded-2xl bg-secondary-light text-left align-middle">
              <div className="absolute right-2 top-2 flex flex-shrink-0 items-center justify-end">
                <button type="button" className="box-content w-8 h-8 text-white lg:max-4k:text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:opacity-75 hover:no-underline" onClick={closeModal}>
                  <FaClose className="text-2xl text-body" />
                </button>
              </div>
              <FeedbackContent questionId={props.questionId.toString()} />
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default DislikeFeedbackModal